import { SearchActionPayload } from "@/domain/action.interface";
import { ActionsService } from "@/services/actions.service";
import { useQuery } from "@tanstack/react-query";

export const useSearchActions = ({
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
  search,
}: SearchActionPayload) => {
  const {
    data: actionsResponse,
    isLoading: isLoadingActions,
    isFetching: isFetchingActions,
    refetch: refetchActions,
  } = useQuery({
    queryKey: ["actions", sortField, sortOrder, pageNumber, pageSize, search],
    queryFn: () =>
      ActionsService.search({
        sortField,
        sortOrder,
        pageNumber,
        pageSize,
        search,
      }),
  });

  return {
    actionsResponse,
    isLoadingActions,
    isFetchingActions,
    refetchActions,
  };
};
